import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivityDetail } from '../models/activity-detail.model';
import { Observable } from 'rxjs';

@Injectable()
export class ReportingService {
  constructor(private http: HttpClient) {/**/}

  /**
   * Returns club activity summary by club id
   * @param {number} clubId
   * @param {number} startDate
   * @param {number} endDate
   * @param {number} pageNumber
   * @param {number} rowsPerPage
   * @returns {Observable<Detail>}
   */
  public getClubActivitySummary(
    clubId: number,
    startDate: number,
    endDate: number
  ): Observable<ActivityDetail> {
    const params: any = {
      startDate,
      endDate
    };
    return this.http.get(
      `reportingApi://clubs/${clubId}/activitysummary`,
      {params}) as Observable<ActivityDetail>;
  }

  public getActivitiesDetailLCIAsCSV(start, end): Observable<any> {
    const requestHeaders = new HttpHeaders().set('Content-Type', 'text/csv')
      .append('Accept', 'application/csv')
      .append('Content-Disposition', 'attachment');
    return this.http.get(
      `reportingApi://lci/activitydetail` +
        `?startDate=${start}&endDate=${end}&pageNumber=1&rowsPerPage=99999`,
      {responseType: 'text', headers: requestHeaders}) as Observable<any>;
  }

  public getActivitiesDetailClubAsCSV(start, end, clubId): Observable<any> {
    const requestHeaders = new HttpHeaders().set('Content-Type', 'text/csv')
      .append('Accept', 'application/csv')
      .append('Content-Disposition', 'attachment');
    return this.http.get(
      `reportingApi://clubs/${clubId}/activitydetail` +
            `?startDate=${start}&endDate=${end}&pageNumber=1&rowsPerPage=99999`,
      {responseType: 'text', headers: requestHeaders}) as Observable<any>;
  }

  public getActivitiesDetailDistrictAsCSV(start, end, districtId): Observable<any> {
    const requestHeaders = new HttpHeaders().set('Content-Type', 'text/csv')
      .append('Accept', 'application/csv')
      .append('Content-Disposition', 'attachment');
    return this.http.get(
      `reportingApi://districts/${districtId}/activitydetail` +
            `?startDate=${start}&endDate=${end}&pageNumber=1&rowsPerPage=99999`,
      {responseType: 'text', headers: requestHeaders}) as Observable<any>;
  }

  public getActivitiesDetailMultiDistrictAsCSV(start, end, multipleDistrictId): Observable<any> {
    const requestHeaders = new HttpHeaders().set('Content-Type', 'text/csv')
      .append('Accept', 'application/csv')
      .append('Content-Disposition', 'attachment');
    return this.http.get(
        `reportingApi://multipledistricts/${multipleDistrictId}/activitydetail` +
              `?startDate=${start}&endDate=${end}&pageNumber=1&rowsPerPage=99999`,
      {responseType: 'text', headers: requestHeaders}) as Observable<any>;
  }

  public getActivitiesDetailConstitutionalAreaAsCSV(start, end, constitutionalAreaId): Observable<any> {
    const requestHeaders = new HttpHeaders().set('Content-Type', 'text/csv')
      .append('Accept', 'application/csv')
      .append('Content-Disposition', 'attachment');
    return this.http.get(
      `reportingApi://constitutionalArea/${constitutionalAreaId}/activitydetail` +
              `?startDate=${start}&endDate=${end}&pageNumber=1&rowsPerPage=99999`,
      {responseType: 'text', headers: requestHeaders}) as Observable<any>;
  }
}
